import { Check, LayoutDashboard, ShieldCheck, Smartphone } from "lucide-react";
import { Eyebrow, Item, Reveal, Stagger } from "../components/Reveal";

const AUDIENCES = [
  {
    icon: LayoutDashboard,
    tag: "Operação",
    tagColor: "bg-brand/10 text-brand",
    title: "Imobiliárias",
    desc: "Mais organização e menos operação manual.",
    bullets: ["Chamados centralizados", "Prestadores sob controle", "Time livre para fechar negócios"],
    footer: "A operação roda. Sua equipe vende.",
    accent: "group-hover:border-brand/50",
    iconBox: "bg-petrol text-white group-hover:bg-brand",
  },
  {
    icon: ShieldCheck,
    tag: "Tranquilidade",
    tagColor: "bg-emerald-500/10 text-emerald-600",
    title: "Proprietários",
    desc: "Mais transparência e praticidade na resolução de problemas.",
    bullets: ["Orçamentos claros antes da execução", "Aprovação em cada etapa", "Histórico completo do imóvel"],
    footer: "Você decide. A Resolv executa.",
    accent: "group-hover:border-emerald-400/60",
    iconBox: "bg-petrol text-white group-hover:bg-emerald-500",
  },
  {
    icon: Smartphone,
    tag: "Simplicidade",
    tagColor: "bg-amber-500/10 text-amber-600",
    title: "Inquilinos",
    desc: "Um canal simples para solicitar e acompanhar soluções.",
    bullets: ["Solicitação em poucos minutos", "Acompanhamento de cada etapa", "Sem telefone ocupado ou planilha perdida"],
    footer: "Abriu, acompanhou, resolveu.",
    accent: "group-hover:border-amber-400/60",
    iconBox: "bg-petrol text-white group-hover:bg-amber-500",
  },
];

export const Audiences = () => (
  <section
    id="para-quem"
    className="relative overflow-hidden bg-slate-100/60 py-24 lg:py-32"
    data-testid="audiences-section"
  >
    <div className="glow-brand pointer-events-none absolute -left-48 bottom-0 h-[420px] w-[420px] rounded-full" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <Eyebrow>Para quem é</Eyebrow>
        <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-petrol sm:text-3xl lg:text-4xl">
          Um problema, três pontas. <span className="text-brand">A Resolv conecta todas.</span>
        </h2>
      </Reveal>

      <Stagger className="mt-14 grid gap-6 lg:grid-cols-3">
        {AUDIENCES.map((a, i) => (
          <Item key={a.title} data-testid={`audience-card-${a.title.toLowerCase()}`}>
            <div
              className={`group flex h-full flex-col rounded-3xl border border-slate-200/80 bg-white p-8 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1.5 hover:shadow-[0_30px_60px_-25px_rgba(11,25,44,0.25)] ${a.accent} ${
                i === 1 ? "lg:-translate-y-3" : ""
              }`}
            >
              <div className="flex items-center justify-between">
                <span
                  className={`flex h-13 w-13 items-center justify-center rounded-2xl p-3 transition-colors duration-300 ${a.iconBox}`}
                >
                  <a.icon className="h-6 w-6" strokeWidth={1.8} />
                </span>
                <span
                  className={`rounded-full px-3 py-1 font-mono text-[0.6rem] font-semibold uppercase tracking-[0.2em] ${a.tagColor}`}
                >
                  {a.tag}
                </span>
              </div>
              <h3 className="mt-7 font-display text-xl font-bold uppercase tracking-wide text-petrol">
                {a.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{a.desc}</p>
              <ul className="mt-6 flex-1 space-y-3">
                {a.bullets.map((b) => (
                  <li key={b} className="flex items-start gap-2.5 text-sm text-slate-600">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-brand" strokeWidth={3} />
                    {b}
                  </li>
                ))}
              </ul>
              <p className="mt-7 border-t border-slate-100 pt-5 font-display text-sm font-semibold text-petrol">
                {a.footer}
              </p>
            </div>
          </Item>
        ))}
      </Stagger>
    </div>
  </section>
);
